import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=58174fa8&scoped=true&"
import script from "./FilePreview.vue?vue&type=script&lang=js&"
export * from "./FilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58174fa8",
  null
  
)

export default component.exports